export enum RoomTypeEnum {
  /** Warehouse */
  WAREHOUSE = 'WAREHOUSE',
  /** An office with an area less than or equal to 45 sq. m. */
  OFFICE_SQUARE_LTE_45 = 'OFFICE_SQUARE_LTE_45',
  /** Office with an area greater than 45 sq. m. */
  OFFICE_SQUARE_GT_45 = 'OFFICE_SQUARE_GT_45',
  /** Retail */
  RETAIL = 'RETAIL',
}
